// FPEL 2026 — the season in progress. Pure data — see src/seasons/index.js.
//
// TODO(luke): the draft date and key dates below are placeholders; correct
// them once the real schedule is set. The elimination format fields stay null
// until the 2026 rules are final — the danger board reads them, so fill them
// in before the first elimination week.
const season2026 = {
  season: 2026,
  leagueId: 175750856,
  label: 'Season 4',

  // ISO strings with an explicit Eastern offset so parsing is unambiguous.
  draftDate: '2026-09-07T20:00:00-04:00',
  weekOneKickoff: '2026-09-10T20:15:00-04:00',

  keyDates: [
    { date: 'Sep 7', label: 'Live draft · 8:00 PM ET' },
    { date: 'Sep 10', label: 'Week 1 kickoff' },
    { date: 'TBD', label: 'First elimination week', critical: true },
  ],

  // Elimination format: which week eliminations begin, plus per-week
  // overrides for the human moments (double eliminations, zombie outcomes,
  // commissioner adjustments). Everything else is derived from scores.
  eliminationStartWeek: 3,
  weekOverrides: {
    6: { eliminations: 2 },
    9: { eliminations: 2 },
  },

  results: null, // season in progress
};

export default season2026;
